import React from 'react';
import { Card, CardHeader, CardTitle, CardBody, CardActions, CardImage, CardSubtitle, Avatar } from '@progress/kendo-react-layout';

export default function PlanCards(props) {
    return (
        <div className="add-new-campaign-plan-cards" >
            <Card className="login-card">
                <CardBody>
                    <CardTitle>
                        <h1>
                            Plan Title
                        </h1>
                    </CardTitle>
                
                    <h6 className="plan-card-description" >
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into
                        electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passag
                    </h6>
                </CardBody>
            </Card>
            <Card className="login-card">
                <CardBody>
                    <CardTitle>
                        <h1>
                            Plan Title
                        </h1>
                    </CardTitle>
                    <h6 className="plan-card-description"  >
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into
                        electronic typesetting
                    </h6>
                </CardBody>
            </Card>
            <Card className="login-card">
                <CardBody>
                    <CardTitle>
                        <h1>
                            Plan Title
                        </h1>
                    </CardTitle>
                    <h6 className="plan-card-description" >
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into
                        electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,
                        and more recently with
                    </h6>
                </CardBody>
            </Card>


        </div>
    );
}

